import { Controller } from "@hotwired/stimulus"
import { loadGoogleMaps } from "../../src/shared/google_maps_loader"
import MapStyle from "src/shared/resources/map-style-light.json"

// « Comparer les tracés » of a sector history (Ui::Admin::AuditHistory::OutlineComparisonComponent): the former
// outline in red, the new one in blue, framed together. The modal loads this only when it opens, and Google Maps
// with it.
const FORMER_OPTIONS = { strokeColor: "#DC3545", strokeWeight: 2, fillColor: "#DC3545", fillOpacity: 0.08, zIndex: 1 }
const CURRENT_OPTIONS = { strokeColor: "#0D6EFD", strokeWeight: 3, fillColor: "#0D6EFD", fillOpacity: 0.12, zIndex: 2 }

export default class extends Controller {
  static values = { former: Array, current: Array }

  async connect () {
    const connection = (this.connection = Symbol("connection"))
    const maps = await loadGoogleMaps()
    if (this.connection !== connection) return

    this.map = new maps.Map(this.element, {
      styles: MapStyle,
      disableDefaultUI: true,
      zoomControl: true,
      zoomControlOptions: { position: maps.ControlPosition.LEFT_TOP }
    })
    const bounds = new maps.LatLngBounds()
    this.polygons = [
      [this.formerValue, FORMER_OPTIONS],
      [this.currentValue, CURRENT_OPTIONS]
    ].filter(([paths]) => paths.length > 2).map(([paths, options]) => {
      paths.forEach((point) => bounds.extend(point))
      return new maps.Polygon({ ...options, paths, map: this.map, clickable: false })
    })
    if (!bounds.isEmpty()) this.map.fitBounds(bounds, 24)
  }

  disconnect () {
    this.connection = null
    this.polygons?.forEach((polygon) => polygon.setMap(null))
    this.polygons = null
    this.map = null
  }
}
